module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editChecksDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editChecksForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM1000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditChecks",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditChecksGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditChecks",
      "href": "#collapseEditChecksGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditChecksGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CM1001))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditChecksGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditChecksGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceExternalInterface')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceExternalInterface >
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceExternalInterface <
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1003))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceExternalCustom')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceExternalCustom > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceExternalCustom < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1004))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceQueryTool')
      }
    }
  }, [(_vm.generalSettingsData.SurveyInstanceQueryTool > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceQueryTool < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1005))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceDashboard')
      }
    }
  }, [(_vm.generalSettingsData.SurveyInstanceDashboard > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceDashboard < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1006))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceCheckExplorer')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceCheckExplorer > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceCheckExplorer < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1007))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceAggregatedReport')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceAggregatedReport >
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceAggregatedReport <
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1008))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceRawDataExports')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceRawDataExports > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceRawDataExports < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1009))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceFrequencies')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceFrequencies > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceFrequencies < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1010))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceMediaExplorer')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceMediaExplorer > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceMediaExplorer < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1011))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCustomReportingDateCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr(
          'inputCustomReportingDateCheckMgmtEdit'
        )
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.generalSettingsData.SurveyInstanceCustomReportingDate
      ),
      expression: "\n                            generalSettingsData.SurveyInstanceCustomReportingDate\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCustomReportingDateCheckMgmtEdit",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    domProps: {
      "value": (
        _vm.generalSettingsData.SurveyInstanceCustomReportingDate
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceCustomReportingDate", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.languageStringsReceived && !_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectSurveyInstanceType"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectSurveyInstanceType"
    },
    on: {
      "change": _vm.surveyInstanceTypeChanged
    },
    model: {
      value: (_vm.generalSettingsData.SurveyInstanceType),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceType", $$v)
      },
      expression: "generalSettingsData.SurveyInstanceType"
    }
  }, [_c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1037))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1038))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1039))])])], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.generalSettingsData.SurveyInstanceType === 'FO' ||
    _vm.generalSettingsData.SurveyInstanceType === 'MA'
  ) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectUser"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectUser",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "change": function($event) {
        delete _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid,
          delete _vm.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedShopperGuid", $$v)
      },
      expression: "\n                            generalSettingsData.SurveyInstanceAssignedShopperGuid\n                          "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.shopperList), function(user, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": guid
      }
    }, [_vm._v("\n                            " + _vm._s(user) + "\n                          ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.generalSettingsData.SurveyInstanceType === 'AG') ? [(
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('leadAgencies')
  ) ? [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLeadAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1066))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    ref: "checkEditSelectLeadAgency",
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLeadAgency",
      "disabled": _vm.generalSettingsData.IsReadonly ||
        (_vm.feature.isAudiTarget &&
          _vm.generalSettingsData.MaxSurveyInstanceStatusId >
          50)
    },
    on: {
      "change": function($event) {
        delete _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid,
          delete _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLeadAgencyGuid", $$v)
      },
      expression: "\n                                generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid\n                              "
    }
  }, _vm._l((_vm.leadAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                                " + _vm._s(agency.AgencyName) + "\n                              ")])
  }), 0)], 1)]), _vm._v(" "), (!_vm.globals.currentUserInfo.IsAudiUser) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLocalAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1067))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    ref: "checkEditSelectLocalAgency",
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLocalAgency",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "change": function($event) {
        delete _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLocalAgencyGuid", $$v)
      },
      expression: "\n                                generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid\n                              "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.localAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                                " + _vm._s(agency.AgencyName) + "\n                              ")])
  })], 2)], 1)]) : _vm._e()] : _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1016))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectAgency",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "change": function($event) {
        delete _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLocalAgencyGuid", $$v)
      },
      expression: "\n                              generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid\n                            "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                              " + _vm._s(agency.AgencyName) + "\n                            ")])
  })], 2)], 1)])] : _vm._e(), _vm._v(" "), (_vm.projectSelected) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectWave"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectWave",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "change": function($event) {
        _vm.generalSettingsData.SurveyInstanceScenarioGuid =
          ''
      }
    },
    model: {
      value: (_vm.generalSettingsData.SurveyInstanceWaveGuid),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceWaveGuid", $$v)
      },
      expression: "generalSettingsData.SurveyInstanceWaveGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.wavesOfProject), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                            " + _vm._s(wave.WaveName) + "\n                          ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.projectSelected) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectScenario"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1014))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectScenario",
      "disabled": _vm.generalSettingsData.IsReadonly ||
        !_vm.generalSettingsData.SurveyInstanceWaveGuid,
      "placeholder": ' ',
      "allowClear": true
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceScenarioGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceScenarioGuid", $$v)
      },
      expression: "\n                            generalSettingsData.SurveyInstanceScenarioGuid\n                          "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.scenariosOfWave), function(scenario) {
    return _c('option', {
      key: scenario.ScenarioGuid,
      domProps: {
        "value": scenario.ScenarioGuid
      }
    }, [_vm._v("\n                            " + _vm._s(scenario.ScenarioName) + "\n                          ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.projectSelected) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLocation"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLocation",
      "disabled": _vm.generalSettingsData.IsReadonly ||
        _vm.generalSettingsData.MaxSurveyInstanceStatusId >
        190 ||
        _vm.generalSettingsData.SurveyInstanceLocationGuid ==
        '-1'
    },
    on: {
      "change": function($event) {
        return _vm.selectedLocationChanged()
      }
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceLocationGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceLocationGuid", $$v)
      },
      expression: "\n                            generalSettingsData.SurveyInstanceLocationGuid\n                          "
    }
  }, _vm._l((_vm.locationsOfSelectedClient), function(location) {
    return _c('option', {
      key: location.LocationGuid,
      domProps: {
        "value": location.LocationGuid
      }
    }, [_vm._v("\n                            (" + _vm._s(location.LocationStoreId) + ")\n                            " + _vm._s(location.LocationAddress) + "\n                          ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('briefingAndSurveyDocs') &&
    _vm.selectedProject
  ) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectBriefing"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectBriefing",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly ||
        _vm.generalSettingsData.MaxSurveyInstanceStatusId >
        190 ||
        _vm.generalSettingsData.BriefingDownloadGuid === '-1'
    },
    model: {
      value: (_vm.generalSettingsData.BriefingDownloadGuid),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "BriefingDownloadGuid", $$v)
      },
      expression: "generalSettingsData.BriefingDownloadGuid"
    }
  }, _vm._l((_vm.briefingAttachments), function(briefing) {
    return _c('option', {
      key: briefing.DownloadId,
      domProps: {
        "value": briefing.DownloadId
      }
    }, [_vm._v("\n                            " + _vm._s(briefing.FileName) + "\n                          ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('briefingAndSurveyDocs') &&
    _vm.selectedProject
  ) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectSurvey"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectSurvey",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.generalSettingsData.IsReadonly ||
        _vm.generalSettingsData.MaxSurveyInstanceStatusId >
        190 ||
        _vm.generalSettingsData.SurveyDownloadGuid === '-1'
    },
    model: {
      value: (_vm.generalSettingsData.SurveyDownloadGuid),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyDownloadGuid", $$v)
      },
      expression: "generalSettingsData.SurveyDownloadGuid"
    }
  }, _vm._l((_vm.surveyAttachments), function(survey) {
    return _c('option', {
      key: survey.DownloadId,
      domProps: {
        "value": survey.DownloadId
      }
    }, [_vm._v("\n                            " + _vm._s(survey.FileName) + "\n                          ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditSurveyInstanceInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1056))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceInfo),
      expression: "generalSettingsData.SurveyInstanceInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputCheckEditSurveyInstanceInfo"
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.generalSettingsData.SurveyInstanceType === 'FO'),
      expression: "generalSettingsData.SurveyInstanceType === 'FO'"
    }]
  }, [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputCheckEditStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceSince),
      expression: "generalSettingsData.SurveyInstanceSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCheckEditStartDate"
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1041))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputCheckEditEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceUntil),
      expression: "generalSettingsData.SurveyInstanceUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCheckEditEndDate"
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "selectCheckEditSurveyInstanceSkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1057))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (
        _vm.generalSettingsData.SurveyInstanceSkillLevel
      ),
      expression: "\n                              generalSettingsData.SurveyInstanceSkillLevel\n                            ",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectCheckEditSurveyInstanceSkillLevel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceSkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.CM1061) + "\n                              "), (
    _vm.generalSettingsData.SurveySkillLevel > 0
  ) ? _c('span', [_vm._v("(" + _vm._s(_vm.generalSettingsData.SurveySkillLevel) + ")")]) : _vm._e()]), _vm._v(" "), _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  })], 2)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckEditSurveyInstanceSkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n                          1 → " + _vm._s(_vm.lang.CM1058) + "\n                          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n                          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                          5 → " + _vm._s(_vm.lang.CM1059) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-state",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('OnlineState')
      }
    }
  }, [(_vm.generalSettingsData.OnlineState > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.generalSettingsData.OnlineState < 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1042))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-state",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('LocationFree')
      }
    }
  }, [(_vm.generalSettingsData.LocationFree > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.generalSettingsData.LocationFree < 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1043))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        return _vm.openHtmlEditor()
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.CM1044) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        return _vm.openShopperFilterModal()
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.CM1053) + "\n                        ")])])])], 2)])]), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesAnswers_Read'
    ) && !_vm.generalSettingsData.IsReadonly
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditChecksSpecific",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditChecks",
      "href": "#collapseEditChecksSpecific",
      "aria-expanded": "false",
      "aria-controls": "collapseEditChecksSpecific"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CM1017))])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesAnswers_Read'
    ) && !_vm.generalSettingsData.IsReadonly
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditChecksSpecific",
      "role": "tabpanel",
      "aria-labelledby": "headingEditChecksSpecific"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "checkListContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.CM1018))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "check-list-table"
    }
  }, _vm._l((_vm.specificSettingsData.dataList), function(check, key) {
    return _c('tr', {
      key: key,
      class: {
        info: _vm.specificSettingsData.selectedCheck
          .SurveyInstanceGuid ===
          check.SurveyInstanceGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.specificSettingsData.selectedCheck = check
        }
      }
    }, [_c('td', [_vm._v(_vm._s(check.SurveyInstanceId))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(
    _vm.specificSettingsData.selectedCheck.ApprovedShopper
  ) ? _c('div', {
    staticClass: "shopper-info"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM1068) + ":")]), _vm._v("\n                      " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .DisplayName) + "\n                      "), _c('div', {
    attrs: {
      "id": "approvedShopperDetailsContainer"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM1069) + " (" + _vm._s(_vm.lang.CM1070) + "):\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .ShopperAge) + "\n                        (" + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .Gender) + ")\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1071) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .ShopperCar) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1072) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .CarSegmentName) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1073) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .CarModelName) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputDateOfVisitCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr(
          'inputDateOfVisitCheckMgmtEdit'
        )
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerDateOfVisit
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerDateOfVisit\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDateOfVisitCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerDateOfVisit
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerDateOfVisit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeInCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1020))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputTimeInCheckMgmtEdit')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeIn
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerTimeIn\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTimeInCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeIn
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerTimeIn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeOutCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1021))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputTimeOutCheckMgmtEdit')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeOut
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerTimeOut\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTimeOutCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeOut
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerTimeOut", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoShopper"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoShopper
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoShopper\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "inputMemoShopper",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoShopper
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoShopper", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoAgency
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoAgency\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "inputMemoAgency",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoAgency
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoAgency", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoMSM"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoMSM
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoMSM\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "inputMemoMSM",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoMSM
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoMSM", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputEditSurveyInstanceNote"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1052))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceNote
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceNote\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "maxlength": "1000",
      "id": "inputEditSurveyInstanceNote",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceNote
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceNote", $event.target.value)
      }
    }
  })])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM1025) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesProperties_Update'
      ) || !_vm.generalSettingsData.SurveyInstanceScenarioGuid
    },
    on: {
      "click": function($event) {
        return _vm.saveEditCheckDialogData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM1026) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f54cbfc4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckManagement/CheckManagementEditModal.vue
// module id = 1733
// module chunks = 1